import { SxProps, Typography } from "@outschool/backpack";
import { TFunction } from "@outschool/localization";
import React from "react";

import { SectionRowSection } from "./types";

export default function LateEnrollmentMeetingListDescription({
  section,
  sx = {},
  t,
}: {
  section?: SectionRowSection;
  sx: SxProps;
  t: TFunction;
}) {
  if (
    !section?.allowsLateEnrollment ||
    !section?.progress ||
    section?.progress.pastMeetingCount === 0
  ) {
    return null;
  }

  const { pastMeetingCount, totalMeetingCount } = section.progress;

  return (
    <Typography component="p" variant="body1" sx={{ color: "info.700", ...sx }}>
      {t("1 meeting out of {{totalMeetingCount}} has already occurred.", {
        pastMeetingCount,
        totalMeetingCount,
        count: pastMeetingCount,
        defaultValue_plural:
          "{{pastMeetingCount}} meetings out of {{totalMeetingCount}} have already occurred.",
      })}
    </Typography>
  );
}
